export default __webpack_public_path__ + "static/media/colgante-cruz.344d28d2.png";